import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualItinerario from '../../actions/itinerario/determinarPaginaAtualItinerario'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoItinerarioParaTransferencia extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualItinerario}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualItinerario,
    itinerarios: state.itinerariosFuturo.itinerarios,
    total: state.itinerariosFuturo.total,
    registrosPorPagina: state.registrosPorPaginaItinerario
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualItinerario }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoItinerarioParaTransferencia)
